<!-- 上传图片按钮 -->
<template>
    <div style="height: 100%">
        <el-button icon="el-icon-camera-solid" class="btn-primary" @click="showdialog">图片识别</el-button>
        <el-dialog
            :close-on-click-modal="false"
            title="识别图片功能块"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            custom-class="base-dialog"
            width="800px"
            @close="onClose"
        >
            <div class="dialog-content" style="padding: 0" v-if="dialogVisible" v-loading="loading">
                <el-container style="min-height: 500px">
                    <el-header style="height: auto; text-align: center">
                        <div id="uploadArea" class="el-upload el-upload--text" ref="uploadArea" style="padding-top: 10px">
                            <div class="el-upload-dragger">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">
                                    <p>将文件拖到此区域，</p>
                                    <p>或将图片按Ctrl+V 粘贴至此区域，</p>
                                    <p>
                                        或
                                        <em @click="uploadBtnClick">点击上传本地图片</em>
                                        <input type="file" ref="uploadBtn" accept="image/*" @change="uploadBtnChange($event)" style="opacity: 0; display: none" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-header>
                    <el-main class="resultzone" style="height: 200px">
                        <div class="imgzone">
                            <el-card class="box-card" v-for="(item, index) in previewImgList" :key="index" :body-style="{ height: '100%', position: 'relative' }">
                                <i class="el-icon-close closebtn" @click="removePreviewImg(item, index)"></i>
                                <div class="imgpo">
                                    <img :src="item" />
                                </div>
                            </el-card>
                        </div>
                        <div class="result">
                            <div v-if="isNonResult" class="nonresult">很抱歉，没有识别出对应的结果，您可以尝试上传更加清晰的图片哟！</div>
                            <div v-else>
                                <div class="title">识别结果：</div>
                                <div>
                                    <el-button class="btnTxt" v-for="(item, index) in resultList" :key="index" type="primary" plain @click="gotoSearch(item)">{{ item }}</el-button>
                                </div>
                            </div>
                        </div>
                    </el-main>
                </el-container>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="previewList" :initial-index="initialIndex" :z-index="99999"/>
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    name: 'uploadImg',
    components: { ElImageViewer },
    props: {
        limit: {
            type: Number,
            default: 999
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            loading: false,
            resultList: [],
            isNonResult: false,
            uploadData: {
                key: this.type,
                isPrivate: false
            },
            dialogVisible: false,
            previewImgList: [], //预览图片列表

            showViewer: false, // 是否显示预览图片
            initialIndex: 0, // 初始化展示哪张图片
            previewList: [], // 上传图片预览列表
            token: this.$util.getLocalStorage('userMsg') ? this.$util.getLocalStorage('userMsg').Token : ''
        };
    },
    mounted() {},
    beforeDestroy() {
        //注销粘贴事件
        document.removeEventListener('paste', this.handlePaste, false);
    },
    methods: {
        showdialog() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                let uploadArea = document.querySelector('#uploadArea');
                uploadArea.addEventListener('dragenter', this.onDrag, false);
                uploadArea.addEventListener('dragover', this.onDrag, false);
                uploadArea.addEventListener('drop', this.onDrop, false);
                document.addEventListener('paste', this.handlePaste, false);
            });
        },
        //关闭弹窗
        onClose() {
            //注销粘贴事件
            document.removeEventListener('paste', this.handlePaste, false);
            this.dialogVisible = false;
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        uploadBtnClick() {
            this.$refs.uploadBtn.click();
        },
        uploadBtnChange(e) {
            let that = this;
            let imgfile = this.$refs.uploadBtn;

            that.previewImgList = [];
            for (let i = 0; i < imgfile.files.length; i++) {
                if (!that.uploadCheck(imgfile.files[i])) {
                    return;
                }

                that.loading = true;
                let reader = new FileReader();
                reader.readAsDataURL(imgfile.files[i]);
                reader.onload = function () {
                    that.previewImgList.push(this.result);

                    let imgBase64 = this.result.split(',')[1];
                    let fd = new window.FormData();
                    fd.append('imgBase64', imgBase64);
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                    xhr.setRequestHeader('access-key', that.token);
                    xhr.setRequestHeader('reqApp', 'yqgPC');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            let res = JSON.parse(xhr.responseText);
                            if (res.errcode == 0) {
                                let data = res.data;
                                if (data && data.length > 0) {
                                    that.resultList = data;
                                    that.isNonResult = false;
                                } else that.isNonResult = true;
                                that.loading = false;
                            } else {
                                that.isNonResult = true;
                            }
                        }
                        that.loading = false;
                    };
                    xhr.onerror = () => {
                        that.$util.errorMsg('识别失败');
                        that.loading = false;
                    };
                    xhr.send(fd);
                };
            }
        },
        uploadCheck(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            //改成10M
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt20M) {
                this.$util.warningMsg('上传图片大小不能超过 10MB!');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt20M;
        },
        //拖拽上传
        onDrop: function (e) {
            e.stopPropagation();
            e.preventDefault();
            let that = this;
            let dt = e.dataTransfer;

            if (dt.files.length > 1) {
                this.$util.warningMsg('只能上传一张图片!');
                return;
            }

            that.previewImgList = [];

            for (let i = 0; i < dt.files.length; i++) {
                if (!that.uploadCheck(dt.files[i])) {
                    return;
                }

                that.loading = true;
                let reader = new FileReader();
                reader.readAsDataURL(dt.files[i]);
                reader.onload = function () {
                    that.previewImgList.push(this.result);

                    let imgBase64 = this.result.split(',')[1];
                    let fd = new window.FormData();
                    fd.append('imgBase64', imgBase64);
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                    xhr.setRequestHeader('access-key', that.token);
                    xhr.setRequestHeader('reqApp', 'yqgPC');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            let res = JSON.parse(xhr.responseText);
                            if (res.errcode == 0) {
                                let data = res.data;
                                if (data && data.length > 0) {
                                    that.resultList = data;
                                    that.isNonResult = false;
                                } else that.isNonResult = true;
                                that.loading = false;
                            } else {
                                that.isNonResult = true;
                            }
                        }
                        that.loading = false;
                    };
                    xhr.onerror = () => {
                        that.$util.errorMsg('识别失败');
                        that.loading = false;
                    };
                    xhr.send(fd);
                };
            }
        },
        // 监听粘贴操作
        handlePaste(event) {
            if (!this.dialogVisible) return false;

            let that = this;
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;

            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持粘贴模式');
                return;
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (!file) {
                // this.$message.error("粘贴内容非图片");
                return;
            }

            if (!that.uploadCheck(file)) {
                return;
            }
            that.previewImgList = [];

            that.loading = true;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (event) {
                that.previewImgList.push(event.target.result);
                let imgBase64 = this.result.split(',')[1];
                let fd = new window.FormData();
                fd.append('imgBase64', imgBase64);
                let xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                xhr.setRequestHeader('access-key', that.token);
                xhr.setRequestHeader('reqApp', 'yqgPC');
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let res = JSON.parse(xhr.responseText);
                        if (res.errcode == 0) {
                            let data = res.data;
                            if (data && data.length > 0) {
                                that.resultList = data;
                                that.isNonResult = false;
                            } else that.isNonResult = true;
                            that.loading = false;
                        } else {
                            that.isNonResult = true;
                        }
                    }
                    that.loading = false;
                };
                xhr.onerror = () => {
                    that.$util.errorMsg('识别失败');
                    that.loading = false;
                };
                xhr.send(fd);
            };
        },
        //删除预览文件
        removePreviewImg(file, index) {
            this.previewImgList.splice(index, 1);
        },
        // 关闭查看器
        closeViewer() {
            this.showViewer = false;
        },
        // 打开上传图片预览
        onPreview(row, index) {
            this.initialIndex = index;
            this.previewList = row.map(item => this.downloadUrl + item);
            this.showViewer = true;
        },
        gotoSearch(txt) {
            if (txt) {
                this.$emit('getVINTxt', txt);
                this.dialogVisible = false;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-upload-dragger {
    width: 700px;
}
.resultzone {
    display: flex;
    direction: column;
}
.imgzone {
    display: flex;
    width: 40%;
    justify-content: center;
    align-items: center;
    padding: 10px;
}
.result {
    display: flex;
    flex-direction: row;
    width: 60%;
    padding: 20px;
    .title {
        font-size: 18px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .nonresult {
        font-size: 16;
        color: rgb(214, 122, 122);
    }
}
.btnTxt {
    margin-top: 10px;
    margin-bottom: 10px;
}
.box-card {
    height: 100%;
    width: 100%;
    img {
        max-width: 100%;
        max-height: 100%;
    }
    .closebtn {
        position: absolute;
        right: 0px;
        background-color: #909399;
        border-radius: 50%;
        padding: 1px;
        cursor: pointer;
    }
}
.el-upload-list__item {
    z-index: 99;
}
.imgpo {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
